module.exports = __webpack_public_path__ + "static/media/vokal.d086d6e9.png";